<template>
  <el-dialog
    :title="typeTitle === 'add' ? '新增模块' : '修改模块'"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="sectionRules"
      label-width="110px"
    >
      <el-form-item label="板块名称" prop="title">
        <el-input v-model="form.title" placeholder="请输入板块名称"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.comment" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getCommunityListApi,} from "@/api/publish";
  import {addFeedbackApi} from "@/api/online-survey";
  import {MessageError, MessageWarning,MessageSuccess} from "@custom/message";
  import { detailFeedbackApi,updateFeedbackApi } from "@/api/online-survey";
export default {
      name: "layer-survey-dialog",
      data() {
        return {
            dialogVisible: false,
            typeTitle:"add",
            superUuid:"",
            form:{
              title:"",
              comment:"",
            },
            sectionRules: {
              title: [{ required: true, message: '请输入板块名称', trigger: 'blur' }]
            },
            communityList: [],
            uuid:"",//上一层uuid
        }
    },
  props: {
    scopeOptions: { type: Array, default: () => [] }
  },
  computed: {
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.form ={title:"",comment:"",}
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const {title,comment, }= this.form
          let params = {
            title,comment,
            nodeType:801252,//其他
            superUuid:this.superUuid
          }
          const loading = this.$loading({lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
          // 判断是否编辑：存在uuid则走更新接口，否则新增
          if (this.typeTitle !=='add') {
            // 修改追加uuid参数
            params.uuid = this.uuid
            updateFeedbackApi(params)
              .then(res => {
                MessageSuccess('修改成功');
                this.handleClose();
                this.$emit('handleSearch');
              })
              .catch(err => {
                // 可选：失败提示
                MessageError('修改失败')
              })
              .finally(() => loading.close());
          }else{
            params.superUuid = this.uuid
            console.log('params',params);
            
             addFeedbackApi(params).then(res => {
              MessageSuccess('添加成功');
              this.handleClose();
              this.$emit('handleSearch');

          })
          .finally(() => loading.close());
          }

        }
      })
    },
        async openDialog(type,row) {
            const that = this;
            console.log('row',row);
            this.typeTitle = type;
            this.uuid = row.uuid; //当前行uuid
            this.superUuid = row.superUuid; //当前行uuid
            console.log('this.superUuid',this.superUuid);
            if(this.typeTitle !=='add'){
             await this.handleSurveyInfo();
            }

            that.dialogVisible = true;
        },
       // 请求问卷详情
   async handleSurveyInfo() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    await  detailFeedbackApi({ uuid: this.uuid })
        .then(res => {
          this.form.comment = res.info.comment;
          this.form.title = res.info.title;
          // 后端返回作答数据后赋值 answerMap
          // this.answerMap = {
          //   填空uuid: "文字",
          //   单选uuid: "A.xxx",
          //   多选uuid: ["A.xxx", "B.xxx"]
          // }
          loading.close()
        })
        .catch(() => loading.close());
    },              
  },

  mounted() {
      getCommunityListApi().then(res => {
          this.communityList = res.list;
       });
  },
}
</script>
